import clsx from 'clsx';
import React from 'react';

import { createStyles } from "./styles";

var TableCell = function TableCell(props) {
  var classes = createStyles(props);
  var children = props.children,className = props.className,_onClick = props.onClick,id = props.id;

  // Component actions
  var keyPressHandler = function keyPressHandler(e) {
    if (e.keyCode === 13) {
      if (_onClick) {
        _onClick(e);
      }
    }
  };
  return /*#__PURE__*/(
    React.createElement("td", {
      id: id,
      className: clsx(classes.tableCell, className),
      onKeyDown: keyPressHandler,
      onClick: function onClick(e) {return _onClick && _onClick(e);},
      role: "gridcell" },

    children !== undefined ? children : ''));


};

export default TableCell;
//# sourceMappingURL=index.js.map